import Head from 'next/head';
import SiteLayout from '@/components/layout/SiteLayout';
import { PhilosopheSection } from '@/components/sections/PhilosopheSection';
import { philosophieAbschnitte } from '@/lib/content/texte';

const seo = {
  title: 'Marlene Gujan Architektur AG | Philosophie',
  description: 'Erfahren Sie mehr über die Philosophie der Marlene Gujan Architektur AG in Igis. Unsere Grundsätze und Werte, die unsere Arbeit prägen.',
  keywords: 'Philosophie, Marlene Gujan, Architektur, Igis, Grundsätze, Werte',
  canonicalUrl: 'https://www.gujan-architektur.ch/buero/philosophie',
};

export default function Philosophie({ data }) {
  return (
    <SiteLayout>
      <Head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonicalUrl} />
      </Head>
      <PhilosopheSection data={data} />
    </SiteLayout>
  );
}

export async function getStaticProps() {
  return { props: { data: await philosophieAbschnitte() }, revalidate: 300 };
}
